export default __webpack_public_path__ + "static/media/fire-protection.af721088.png";